/* eslint-disable import/no-anonymous-default-export */
import {
  faBook,
  faBuilding,
  faImage,
  faSignOut,
  faTachometer,
  faTasks,
  faTicket,
  faUsers,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { onHamburgerClickedState } from "../../AppState";
import { useAuthStore } from "../../stores/auth-store";

export default () => {
  const navigate = useNavigate();
  const user = useAuthStore((store) => store.user);

  const [onHamburgerClicked] = useRecoilState(onHamburgerClickedState);
  const [showLogoutWarning, setShowLogoutWarning] = useState(false);

  const ignorePathsArr = ["/", "/index", "/login", "/logout"];
  const location = useLocation();

  var arrayLength = ignorePathsArr.length;
  for (var i = 0; i < arrayLength; i++) {
    // console.log(location.pathname, "===", ignorePathsArr[i], " EQUALS ", location.pathname === ignorePathsArr[i]);
    if (location.pathname === ignorePathsArr[i]) {
      return null;
    }
  }

  const ADMIN_SIDEBAR_ITEMS = [
    {
      name: "dashboard",
      path: "/dashboard",
      title: "Dashboard",
      icon: faTachometer,
    },
    {
      name: "organization",
      path: "/organization",
      title: "Organization",
      icon: faBuilding,
    },
    {
      name: "promo-code",
      path: "/promo-code",
      title: "Promo Code",
      icon: faTicket,
    },
    { name: "users", path: "/users", title: "Users", icon: faUsers },
    { name: "resources", path: "/resources", title: "Resources", icon: faBook },
    {
      name: "session-templates",
      path: "/session-templates",
      title: "Session Templates",
      icon: faTasks,
    },
    { name: "cms-videos", path: "/cms-videos", title: "Videos", icon: faVideo },
    { name: "cms-images", path: "/cms-images", title: "Images", icon: faImage },
  ];

  const ORG_SIDEBAR_ITEMS = [
    {
      name: "org-dashboard",
      path: "/org-dashboard",
      title: "Dashboard",
      icon: faTachometer,
    },
    { name: "org-users", path: "/org-users", title: "Users", icon: faUsers },
    {
      name: "org-promo-code",
      path: "/org-promo-code",
      title: "Promo Code",
      icon: faTicket,
    },
  ];

  const options =
    user?.role === "admin" ? ADMIN_SIDEBAR_ITEMS : ORG_SIDEBAR_ITEMS;

  const logOut = () => {
    navigate("/logout");
  };

  return (
    <>
      <div class={`modal ${showLogoutWarning ? "is-active" : ""}`}>
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Are you sure?</p>
            <button
              class="delete"
              aria-label="close"
              onClick={(e) => setShowLogoutWarning(false)}
            ></button>
          </header>
          <section class="modal-card-body">
            You are about to log out of the system and you'll need to log in
            again next time. Are you sure you want to continue?
          </section>
          <footer class="modal-card-foot">
            <div class="button is-success" onClick={() => logOut()}>
              Yes
            </div>
            <button class="button" onClick={(e) => setShowLogoutWarning(false)}>
              No
            </button>
          </footer>
        </div>
      </div>
      <div
        className={`column is-one-fifth has-background-black ${
          onHamburgerClicked ? "" : "is-hidden"
        }`}
      >
        <nav class="level is-hidden-mobile">
          <div class="level-item has-text-centered">
            <figure class="image">
              <img
                src="https://www.getrhea.com/wp-content/themes/duet/images/logo-full.png"
                style={{ maxWidth: "200px" }}
                alt="logo"
              />
            </figure>
          </div>
        </nav>
        <aside class="menu p-4">
          <p class="menu-label has-text-grey-light">Staff</p>
          {options?.map((menu, index) => (
            <ul class="menu-list" key={index}>
              <li>
                <Link
                  to={menu?.path}
                  class={`has-text-grey-light ${
                    location.pathname.includes(menu?.name) && "is-active"
                  }`}
                >
                  <FontAwesomeIcon className="fas" icon={menu?.icon} />
                  &nbsp;{menu?.title}
                </Link>
              </li>
            </ul>
          ))}

          <p class="menu-label has-text-grey-light">Account</p>
          <ul class="menu-list">
            <li>
              <Link
                onClick={(e) => setShowLogoutWarning(true)}
                class={`has-text-grey-light ${
                  location.pathname.includes("logout") && "is-active"
                }`}
              >
                <FontAwesomeIcon className="fas" icon={faSignOut} />
                &nbsp;Sign Off
              </Link>
            </li>
          </ul>
        </aside>
      </div>
    </>
  );
};
